var _dec, _class;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { useCurrencyStore, useFacetsStore, useSearchStore, useSearchWizardStore } from '#imports';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { AppMenuMixin } from '~/apps/app-menu/mixin';
import ErrorCapture from '~/mixins/ErrorCaptured';
import { getCookie } from '~/utility/cookies';
import { getUserCountry } from '~/utility/geo/geo-location';
var Default = (_dec = Component({
  components: {
    'portal-target': () => {
      if (process.client) {
        return import( /* webpackChunkName: "vue-portal", webpackMode: "lazy" */'portal-vue').then(_ref => {
          var {
            PortalTarget
          } = _ref;
          return PortalTarget;
        });
      } else {
        return;
      }
    }
  },
  head: function head() {
    return this.head();
  },
  setup() {
    // to ensure search will load when navigating to search
    var searchStore = useSearchStore(usePinia());
    var searchWizardStore = useSearchWizardStore(usePinia());
    // setup facet store so facets available to all components
    var facetsStore = useFacetsStore();
    // setup to fetch currencies ASAP
    var currencyStore = useCurrencyStore();
    return {
      currencyStore,
      facetsStore,
      searchStore,
      searchWizardStore
    };
  }
}), _dec(_class = class Default extends mixins(AppMenuMixin, ErrorCapture) {
  constructor() {
    super(...arguments);
    this.loadHeader = false;
    this.loadFooter = false;
    this.showLanguageSwitcher = false;
  }
  head() {
    if (!this.$nuxtI18nHead) {
      return {};
    }
    var head = this.$nuxtI18nHead({
      addSeoAttributes: true
    });
    var lang = this.$route.params.lang || 'en-gb';
    var basePath = lang ? this.$route.path.replace("/".concat(lang, "/"), '/') : this.$route.path;
    this.$i18n.locales.forEach(locale => {
      if (locale.code === 'en-gb') {
        ['en-gb', 'en', 'x-default'].forEach(l => {
          head.link.push({
            rel: 'alternate',
            hreflang: l,
            href: "https://".concat(this.$config.public.envUrl).concat(basePath)
          });
        });
      } else {
        head.link.push({
          rel: 'alternate',
          hreflang: locale.code,
          href: "https://".concat(this.$config.public.envUrl, "/").concat(locale.code).concat(basePath)
        });
        if (locale.alternateHreflang) {
          head.link.push({
            rel: 'alternate',
            hreflang: locale.alternateHreflang,
            href: "https://".concat(this.$config.public.envUrl, "/").concat(locale.code).concat(basePath)
          });
        }
      }
    });
    return head;
  }
  mounted() {
    var _this = this;
    return _asyncToGenerator(function* () {
      yield _this.setShowLanguageSwitcher();
    })();
  }
  get userLocaleIso() {
    if (process.client) {
      return navigator.language;
    }
    return null;
  }
  get currentLocale() {
    return this.$i18n.locale;
  }
  setShowLanguageSwitcher() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      if (process.server) {
        return;
      }
      if (!_this2.userLocaleIso || getCookie('hide_language_panel')) return;
      var selectedLocale = localStorage.getItem('pitchup-language-v2');
      if (selectedLocale) return;
      var userLocale = _this2.$i18n.locales.find(l => l.iso === _this2.userLocaleIso);
      if (!userLocale) {
        return;
      }
      // lots of en-gb browsers configured to be en-us or they are crawlers/testtools
      var isUSonGB = userLocale.code === 'en-us' && _this2.currentLocale === 'en-gb';
      if (isUSonGB) {
        var geoLocale = yield getUserCountry();
        if (geoLocale !== 'US') {
          // if they aren't the US, then we can assume they are GB
          return;
        }
      }
      if (userLocale.code !== _this2.currentLocale) {
        yield new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, 3000);
        });
        _this2.showLanguageSwitcher = true;
      }
    })();
  }
}) || _class);
export { Default as default };